import React from "react";
import { notification } from "antd";
import { getTranslation } from "../i18n/i18n-config";
import { rolesInfo, reportTabs, secretKey, mapMonths } from "./properties";
import { difference, indexOf, isEmpty, lowerCase, replace, toLower, toNumber, toString } from "lodash";
import NumberFormat from "react-number-format";
import CryptoJS from "crypto-js";
import dayjs from "dayjs";

export const getUserInfoLocal = (key = "", master = false) => {
  let userInfoLocal = {};
  if (master) {
    userInfoLocal = decryptData(localStorage.getItem("userMaster"));
  } else {
    userInfoLocal = decryptData(localStorage.getItem("userInfo"));
  }
  const userInfo = userInfoLocal;
  let dataReturn = null;
  if (key !== "" && userInfo !== null && userInfo[key]) {
    dataReturn = userInfo[key];
  } else if (key === "") {
    dataReturn = userInfo;
  }
  return dataReturn;
};

export const showError = (error, value = "") => {
  notification.open({
    duration: 5,
    className: "notification-error",
    message: getTranslation("general", "ErrorNotificationTitle"),
    description: getTranslation("errorsCode", error) + " " + value,
  });
};

export const showSuccess = (message = "SuccessNotificationContent", value = "") => {
  notification.open({
    duration: 5,
    className: "notification-success",
    message: getTranslation("general", "SuccessNotificationTitle"),
    description: getTranslation("general", message) + " " + value,
  });
};

// export const getUserMenu = (userInfo) => { // veniva usato con la vecchia struttura menù
//   let returnMenu = {};
//   Object.keys(userMenu).forEach((m) => {
//     returnMenu[m] = [];
//     userMenu[m].forEach((s) => {
//       // In diff value there are the roles that can't see this menu voice
//       let diff = [];
//       diff = difference(s.roles, userInfo.roles);
//       // If diff array and roles array have same length so I not show menu voice
//       if (s.roles.length !== diff.length) {
//         if (
//           (s.name === "salDeclaration" &&
//             userInfo.info.supplierCreateInvoice === true) ||
//           s.name !== "salDeclaration"
//         ) {
//           returnMenu[m].push(s);
//         }
//       }
//     });
//     // After population, I clean empty objects
//     if (returnMenu[m].length === 0) {
//       delete returnMenu[m];
//     }
//   });
//   return returnMenu;
// };

export const getReports = (userInfo) => {
  let returnReport = [];
  reportTabs.forEach((r) => {
    // In diff value there are the roles that can't see this report tabs
    let diff = [];
    diff = difference(r.roles, userInfo.roles);
    // If diff array and roles array have same length so I not show report tabs
    if (r.roles.length !== diff.length) {
      returnReport.push(r);
    }
  });
  return returnReport;
};

export const checkRoles = (userRoles, viewRoles) => {
  let returnView = false;
  let diff = [];
  diff = difference(viewRoles, userRoles);
  if (viewRoles.length !== diff.length) {
    returnView = true;
  }
  return returnView;
};

export const buildQueryString = (actQS, data) => {
  let newQueryString = "";
  Object.keys(data).forEach((k) => {
    actQS[k] = data[k];
  });
  Object.keys(actQS).forEach((k, i) => {
    newQueryString = newQueryString + (i !== 0 ? `&${k}=${!actQS[k] ? "" : actQS[k]}` : `${k}=${actQS[k]}`);
  });
  return { string: newQueryString, obj: actQS };
};

export const stringifyObject = (obj) => {
  let newString = "";
  Object.keys(obj).forEach((k, i) => {
    newString = newString + (i !== 0 ? `&${k}=${!obj[k] ? "" : obj[k]}` : `${k}=${obj[k]}`);
  });
  return newString;
};

export const showAlertHome = (info, role) => {
  let alert = [];
  rolesInfo[role]?.forEach((i) => alert.push(info[i]));
  return indexOf(alert, true);
};

export const formatNumber = (props) => {
  let numberSuffix;
  switch (props.suffix) {
    case "PERCENT":
      numberSuffix = " %";
      break;
    case "HOUR":
      numberSuffix = " h";
      break;
    case "EUR":
      numberSuffix = " €";
      break;
    case "USD":
      numberSuffix = " $";
      break;
    case "GBP":
      numberSuffix = " £";
      break;
    case "CNY":
      numberSuffix = " ¥";
      break;
    default:
      numberSuffix = "";
      break;
  }
  return (
    <NumberFormat
      id={props.id}
      name={props.name}
      value={props.value}
      key={props.key}
      displayType={props.displayType ? props.displayType : "text"}
      thousandSeparator={props.lang === "GB" ? "," : "."}
      decimalSeparator={props.lang === "GB" ? "." : ","}
      decimalScale={indexOf([null, undefined, ""], props.decimalScale) === -1 ? props.decimalScale : 2}
      fixedDecimalScale
      suffix={numberSuffix}
      customInput={props.customInput}
      onChange={props.onChange}
      onBlur={props.onBlur}
      isAllowed={props.isAllowed}
      disabled={props.disabled}
      allowEmptyFormatting={props.displayType === "input"}
      className={props.className}
      onFocus={props.onFocus}
    />
  );
};

export const unformatNumber = (value, lang, type = "amount") => {
  let regexThousand = "";
  if (type === "amount") {
    regexThousand = lang === "GB" ? /([, €])/g : /([. €])/g;
  } else {
    regexThousand = lang === "GB" ? /([, h])/g : /([. h])/g;
  }
  const regexDecimal = lang === "GB" ? /([.])/g : /([,])/g;
  let number = replace(value, regexThousand, "");
  number = replace(number, regexDecimal, ".");
  return toNumber(number);
};

export const salDeclarationCheckValues = (dataContent, finalValue) => {
  let sum = 0;
  dataContent.forEach((dc) => {
    sum += dc.amount;
  });
  return finalValue - sum >= 0;
};

export const exportFile = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.style.display = "none";
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
};

export const passwordStrenght = (password) => {
  let count = 0;
  if (/[0-9]/.test(password)) {
    count++;
  }
  if (/[a-z]/.test(password)) {
    count++;
  }
  if (/[A-Z]/.test(password)) {
    count++;
  }
  if (/[!@#$%^&*?]/.test(password)) {
    count++;
  }
  let returnCounter = count;
  if (password.length >= 8 && count >= 3) {
    returnCounter = 100;
  }
  return returnCounter;
};

export const encryptData = (data) => {
  const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
  return ciphertext;
};

export const decryptData = (ciphertext) => {
  let decryptedData = ciphertext;
  if (ciphertext !== null && ciphertext !== undefined && ciphertext !== "") {
    const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
    decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }
  return decryptedData;
};

export const checkRole = (roles, roleToCheck) => indexOf(roles, roleToCheck) !== -1;

export const trimData = (obj) => {
  Object.keys(obj).forEach((k) => {
    if (k !== "password") {
      if (typeof obj[k] === "string") {
        obj[k] = obj[k].trim();
      } else if (typeof obj[k] === "object" && indexOf([null, undefined], obj[k]) === -1) {
        obj[k] = trimData(obj[k]);
      }
    }
  });
  return obj;
};

export const elaborateWPdata = (wbs, userInfo, type) => {
  let contentExpanded = [];
  let customForm = {};
  if (
    wbs.data &&
    wbs.data.totalQuantityValues &&
    wbs.data.totalQuantityValues.columnValueMap &&
    !isEmpty(wbs.data.costEstimationKickoffValueView)
  ) {
    const totalQuantityValues = wbs.data.totalQuantityValues.columnValueMap;
    totalQuantityValues.activity = "work";
    totalQuantityValues.key = "work";
    totalQuantityValues.isHour = true;
    totalQuantityValues.isOnlyVisual = wbs.data.totalQuantityValues.isOnlyVisual;
    totalQuantityValues.children = [];
    if (wbs.data.costEstimationKickoffValueView) {
      wbs.data.costEstimationKickoffValueView.forEach((cv, i) => {
        if (cv.quantityValues && cv.quantityValues.columnValueMap && cv.serviceType === "HOUR") {
          const childrenValues = cv.quantityValues.columnValueMap;
          childrenValues.activity = cv.activity;
          childrenValues.key = `work-${i}`;
          childrenValues.isHour = true;
          childrenValues.isOnlyVisual = cv.quantityValues.isOnlyVisual;
          totalQuantityValues.children.push(childrenValues);
          if (
            type === "kick-off"
              ? userInfo.canEditKickOff && !cv.quantityValues.isOnlyVisual
              : userInfo.canEditCostEstimation && !cv.quantityValues.isOnlyVisual
          ) {
            // save value in custom form
            customForm[`work-${i}`] = [];
            Object.keys(cv.quantityValues.columnValueMap).forEach((m) => {
              if (mapMonths[lowerCase(m)]) {
                customForm[`work-${i}`].push({
                  month: mapMonths[lowerCase(m)],
                  quantityEstimate: type === "cost-estimation" ? cv.quantityValues.columnValueMap[m] : null,
                  quantityKickOff: type === "kick-off" ? cv.quantityValues.columnValueMap[m] : null,
                  serviceId: cv.serviceId,
                  wbsId: cv.wbsId,
                  year: cv.year,
                });
              }
            });
          }
        }
      });
    }
    contentExpanded.push(totalQuantityValues);
  }
  if (
    wbs.data &&
    wbs.data.totalAmountValues &&
    wbs.data.totalAmountValues.columnValueMap &&
    !isEmpty(wbs.data.costEstimationKickoffValueView)
  ) {
    const totalAmountValues = wbs.data.totalAmountValues.columnValueMap;
    totalAmountValues.activity = "costs";
    totalAmountValues.key = "costs";
    totalAmountValues.isOnlyVisual = wbs.data.totalAmountValues.isOnlyVisual;
    totalAmountValues.children = [];
    if (wbs.data.costEstimationKickoffValueView) {
      wbs.data.costEstimationKickoffValueView.forEach((cv, i) => {
        if (cv.amountValues && cv.amountValues.columnValueMap) {
          const childrenValues = cv.amountValues.columnValueMap;
          childrenValues.activity = cv.activity;
          childrenValues.key = `costs-${i}`;
          childrenValues.isOnlyVisual = cv.amountValues.isOnlyVisual;
          totalAmountValues.children.push(childrenValues);
          if (
            type === "kick-off"
              ? userInfo.canEditKickOff && !cv.amountValues.isOnlyVisual
              : userInfo.canEditCostEstimation && !cv.amountValues.isOnlyVisual
          ) {
            // save value in custom form
            customForm[`costs-${i}`] = [];
            Object.keys(cv.amountValues.columnValueMap).forEach((m) => {
              if (mapMonths[lowerCase(m)]) {
                customForm[`costs-${i}`].push({
                  month: mapMonths[lowerCase(m)],
                  amountEstimate: type === "cost-estimation" ? cv.amountValues.columnValueMap[m] : null,
                  amountKickOff: type === "kick-off" ? cv.amountValues.columnValueMap[m] : null,
                  serviceId: cv.serviceId,
                  wbsId: cv.wbsId,
                  year: cv.year,
                });
              }
            });
          }
        }
      });
    }
    contentExpanded.push(totalAmountValues);
  }
  return { contentExpanded, customForm };
};

export const getClassName = (monthToCheck, openMonth, openYear, actualYear) => {
  openYear = toNumber(openYear);
  actualYear = toNumber(actualYear);
  let className = "past";
  if (actualYear >= openYear) {
    if (actualYear === openYear) {
      if (mapMonths[lowerCase(openMonth)] === mapMonths[lowerCase(monthToCheck)]) {
        className = "present";
      } else if (mapMonths[lowerCase(openMonth)] > mapMonths[lowerCase(monthToCheck)]) {
        className = "past";
      } else {
        className = "future";
      }
    } else {
      className = "future";
    }
  }
  return className;
};

export const checkDate = (startDate, endDate, dateFormat) => {
  if (startDate && endDate) {
    let check = false;
    if (dayjs(startDate, dateFormat).format("X") <= dayjs(endDate, dateFormat).format("X")) check = false;
    else {
      showError(getTranslation("general", "dateError"));
      check = true;
    }
    return check;
  }
};

export const elaborateWCdata = (wbs) => {
  let contentExpanded = [];
  let customForm = [];
  if (wbs.data && wbs.data.totalQuantityValues && !isEmpty(wbs.data.projectCostPlanValues)) {
    const totalQuantityValues = wbs.data.totalQuantityValues;
    /* if (wbs.data.closed && toNumber(wbs.data.openYear) === toNumber(year)) {
      wbs.data.totalQuantityValues[wbs.data.openMonth] = wbs.data.consQuantityOpenMonth;
    } */

    totalQuantityValues.activity = "work";
    totalQuantityValues.totalMap = wbs.data.totalQuantityMap;
    totalQuantityValues.key = "work";
    totalQuantityValues.PRESENT = wbs.data.consQuantityOpenMonth;
    totalQuantityValues.isHour = true;
    totalQuantityValues.isOnlyVisual = true;
    totalQuantityValues.isEditable = wbs.data.editable;
    totalQuantityValues.children = [];
    if (wbs.data.projectCostPlanValues) {
      let totalRunningQuantity = 0;
      wbs.data.projectCostPlanValues.forEach((cv, i) => {
        const childrenValues = [];
        if (cv.quantityValues && cv.unitPrice === "HOUR") {
          cv.quantityValues.forEach((qv) => {
            childrenValues.push(qv);
            childrenValues.activity = cv.serviceId;
            childrenValues.projectTaskId = cv.projectTaskId;
            childrenValues.wbsId = cv.wbsId;
            childrenValues.totalMap = cv.totalQuantityMap;
            childrenValues.key = `work-${i}`;
            childrenValues.isHour = true;
            childrenValues.PRESENT = cv.consQuantityOpenMonth;
            childrenValues.isOnlyVisual = cv.unitPrice !== "HOUR";
            childrenValues.isEditable = wbs.data.editable;
            if (wbs.data.closed && toNumber(wbs.data.openYear) === toNumber(qv.year)) {
              childrenValues[wbs.data.openMonth] = cv.consQuantityOpenMonth;
            }
            childrenValues.runningQuantity = cv.runningQuantity;
          });
          totalQuantityValues.children.push(childrenValues);
        }
        totalRunningQuantity += Number(cv.runningQuantity || 0);
      });
      totalQuantityValues.runningQuantity = totalRunningQuantity;
    }
    contentExpanded.push(totalQuantityValues);
  }
  if (wbs.data && wbs.data.totalAmountValues && !isEmpty(wbs.data.projectCostPlanValues)) {
    const totalAmountValues = wbs.data.totalAmountValues;
    /* if (wbs.data.closed && toNumber(wbs.data.openYear) === toNumber(year)) {
      wbs.data.totalAmountValues[wbs.data.openMonth] = wbs.data.consAmountOpenMonth;
    } */
    totalAmountValues.activity = "costs";
    totalAmountValues.totalMap = wbs.data.totalAmountMap;
    totalAmountValues.key = "costs";
    totalAmountValues.PRESENT = wbs.data.consAmountOpenMonth;
    totalAmountValues.isOnlyVisual = true;
    totalAmountValues.isEditable = wbs.data.editable;
    totalAmountValues.children = [];
    if (wbs.data.projectCostPlanValues) {
      let totalRunningAmount = 0;
      const currentYear = dayjs().year();
      const currentMonth = dayjs().month() + 1;
      wbs.data.projectCostPlanValues.forEach((cv, i) => {
        const childrenValues = [];
        if (cv.amountValues) {
          let presentFutureAmount = 0;
          cv.amountValues.forEach((av) => {
            childrenValues.push(av);
            childrenValues.key = `costs-${i}`;
            childrenValues.activity = cv.serviceId;
            childrenValues.projectTaskId = cv.projectTaskId;
            childrenValues.wbsId = cv.wbsId;
            childrenValues.totalMap = cv.totalAmountMap;
            childrenValues.PRESENT = cv.consAmountOpenMonth;
            childrenValues.isOnlyVisual = cv.unitPrice !== "PERCENT";
            childrenValues.isEditable = wbs.data.editable;
            if (wbs.data.closed && toNumber(wbs.data.openYear) === toNumber(av.year)) {
              childrenValues[wbs.data.openMonth] = cv.consAmountOpenMonth;
            }
            childrenValues.runningAmount = cv.runningAmount;
            childrenValues.rda = cv.rda;
            if (cv.totalAmountMap.TOT_ETC === null || cv.totalAmountMap.TOT_ETC === undefined) {
              // se TOT_ETC non arriva da BE, lo calcoliamo
              if (toNumber(av.year) >= currentYear) {
                Object.entries(av.columnValueMap).forEach(([month, value]) => {
                  if (toNumber(av.year) > currentYear || mapMonths[toLower(month)] >= currentMonth) {
                    presentFutureAmount += value;
                  }
                });
              }
            }
          });
          if (cv.totalAmountMap.TOT_ETC === null || cv.totalAmountMap.TOT_ETC === undefined) {
            childrenValues.totalMap.TOT_ETC = presentFutureAmount; // TOT_ETC = somma dei valori pianificati dal mese corrente compreso in poi
          }
          totalAmountValues.children.push(childrenValues);
        }
        totalRunningAmount += Number(cv.runningAmount || 0);
      });
      totalAmountValues.runningAmount = totalRunningAmount;
    }
    contentExpanded.push(totalAmountValues);
  }
  return { contentExpanded, customForm };
};

export const checkTimesheetDecimals = (decimals, day, column, error, addOne = false) => {
  if (indexOf(["00", "15", "30", "45", "3"], decimals) !== -1) {
    // right
    let diff = difference(error, [`${day}-${column}`]);
    error = diff;
  } else {
    // error
    if (addOne) {
      error.push(`${day + 1}-${column}`);
    } else {
      error.push(`${day}-${column}`);
    }
  }
  return error;
};

export const decimalValueInCent = (value) => {
  let returnVal = value;
  if (returnVal % 1 !== 0) {
    const decimals = toString(value).split(".");
    // means that i have decimals
    switch (decimals[1]) {
      case "15":
        returnVal = toNumber(returnVal) + 0.1;
        break;
      case "30":
        returnVal = toNumber(returnVal) + 0.2;
        break;
      case "3":
        returnVal = toNumber(returnVal) + 0.2;
        break;
      case "45":
        returnVal = toNumber(returnVal) + 0.3;
        break;
      default:
        returnVal = 0;
        break;
    }
  }
  return toNumber(returnVal);
};

export const checkSendInApprove = ({ status, type, flight, documents, traceablePayment }) => {
  let check = false;
  if (status === "PLANNING" || status === "REFUTED") {
    // controllo il tipo
    if (type === "KM") {
      // se km da sempre true
      check = true;
    } else if (type === "FLAT_RATE") {
      // else se flat_rate controllo volo
      if (flight === true) {
        //volo si controllo se c'è doc
        if (documents?.find((doc) => doc.type === "RECEIPT")) {
          check = true;
        }
      } else {
        //volo no sempre true
        check = true;
      }
    } else {
      // per tutti gli altri controllo se ho doc
      if (documents.length > 0) {
        // se ho documenti, devon controllare se c'è un documento con type receipt e/o payment_tracking
        if (!documents.find((doc) => doc.type === "RECEIPT")) {
          check = false;
        } else {
          // Il doc obbligatorio receipt c'è, ora verifico se è richiesto il payment tracking
          if (traceablePayment) {
            const hasPaymentTracking = documents.find((doc) => doc.type === "PAYMENT_TRACKING");
            if (hasPaymentTracking) {
              check = true;
            }
          } else {
            // Il documento di tracciamento non è richiesto, posso proseguire
            check = true;
          }
        }
      }
    }
  }
  return check;
};
